// src/App.tsx
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import WelcomePage from "./pages/WelcomePage"
import LoginPage from "./pages/LoginPage"
import DashboardPage from "./pages/DashboardPage"
import DocumentsPage from "@/components/documents/DocumentsPage"
import TasksPage from "@/pages/TasksPage"
import ReportsPage from "@/pages/ReportsPage"
import CalendarPage from "@/pages/CalendarPage"
import DiskPage from "@/pages/DiskPage"
import AdminUsersPage from "@/pages/AdminUsersPage"
import FormsPage from "@/pages/FormsPage"                    // ← добавили

// Управление аккаунтами
import AccountManagement from "@/components/adminpanel/AccountManagement"

// Новые компоненты админки
import OrganizationsTab from "@/components/adminpanel/OrganizationsTab"
import StructureTab from "@/components/adminpanel/StructureTab"

import SidebarLeft from "./components/SidebarLeft"
import { useAuthStore } from "./store/authStore"
import { useOrganizationsStore } from "./store/organizationsStore"   // ← добавили
import { useEffect } from "react"

// Публичные страницы
import PublicDiskView from "@/components/disk/PublicDiskView"
import VideoFeed from "@/components/video/VideoFeed"
import PublicFormPage from "@/pages/PublicFormPage"          // ← добавили

function ProtectedLayout() {
  const { isAuthenticated, init } = useAuthStore();
  const { init: initOrganizations } = useOrganizationsStore();   // ← инициализация стора организаций

  useEffect(() => {
    init();                    // инициализация авторизации
    initOrganizations();       // инициализация организаций
  }, [init, initOrganizations]);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="flex min-h-screen">
      <SidebarLeft />

      <main className="flex-1 ml-72 px-10 bg-gradient-to-br from-slate-950 via-purple-950 to-indigo-950">
        <Routes>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/tasks"     element={<TasksPage />} />
          <Route path="/documents" element={<DocumentsPage />} />
          <Route path="/reports"   element={<ReportsPage />} />
          <Route path="/forms"     element={<FormsPage />} />   {/* ← новый маршрут */}
          <Route path="/calendar"  element={<CalendarPage />} />
          <Route path="/disk"      element={<DiskPage />} />
          
          {/* Админка */}
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/accounts" element={<AccountManagement />} />
          <Route path="/admin/organizations" element={<OrganizationsTab />} />
          <Route path="/admin/structure" element={<StructureTab />} />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </main>
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Публичные страницы */}
        <Route path="/" element={<WelcomePage />} />
        <Route path="/login" element={<LoginPage />} />

        {/* Публичные просмотры без авторизации */}
        <Route path="/public-disk/:folderId" element={<PublicDiskView />} />
        <Route path="/videos/:folderId" element={<VideoFeed />} />
        <Route path="/f/:formId" element={<PublicFormPage />} />   {/* ← новый публичный маршрут */}

        {/* Все защищённые маршруты */}
        <Route path="/*" element={<ProtectedLayout />} />
      </Routes>
    </BrowserRouter>
  )
}